<template>
    <tr :class="{'disabled': deleted}">
        <td>
            <input type="text" class="form-control" :placeholder="$t('module_name')" v-model="object.name" :disabled="deleted">
        </td>
        <td>
            <datepicker
                v-model="object.from"
                :language="locale"
                input-class="form-control"
                :monday-first="true"
                :clear-button="true"
                clear-button-icon="fa fa-close"
                :disabled="deleted"
            ></datepicker>
        </td>
        <td>
            <datepicker
                v-model="object.until"
                :language="locale"
                input-class="form-control"
                :monday-first="true"
                :clear-button="true"
                clear-button-icon="fa fa-close"
                :disabled="deleted"
            ></datepicker>
        </td>
        <td>
            <multiselect
                v-if="object.users"
                v-model="object.users"
                :options="trainers"
                :disabled="deleted"
                :multiple="true"
                :placeholder="$t('not_assigned')"
                :hide-selected="true"
                label="name"
                track-by="id"
            ></multiselect>

            <select class="form-control" v-model="object.location_id" :disabled="deleted" v-if="locations" required>
                <option value="">{{ $t('not_assigned') }}</option>
                <option v-for="(name, id) in locations" :value="id">{{ name }}</option>
            </select>
        </td>
        <td>
            <span class="btn btn-theme-colored" @click="destroy">
                <i class="fa" :class="{'fa-trash' : deleted == false, 'fa-undo' : deleted == true }"></i>
            </span>
        </td>
    </tr>
</template>

<script>
    import {de, ru} from 'vuejs-datepicker/dist/locale'
    import multiselect from 'vue-multiselect'

    export default {
        components: {multiselect},
        props: {
            initObject: Object,
            locations: Object,
        },
        data: function () {
            return {
                object: this.initObject,
                deleted: false,
            }
        },
        methods: {
            destroy: function () {
                if (this.object.id) {
                    this.deleted = !this.deleted;
                    this.object.deleted = this.deleted;
                } else {
                    if (this.object.name || this.object.from || this.object.until || this.object.users) {
                        if (confirm(this.$i18n.t('confirm_delete_module'))) {
                            this.$emit('destroy', this.object);
                        }
                    } else {
                        this.$emit('destroy', this.object);
                    }
                }
            },
        },
        computed: {
            trainers: function () {
                return this.$store.state.trainers;
            },
            locale: function () {
                var locale = document.getElementsByTagName("html")[0].getAttribute("lang");

                return locale == 'de' ? de : ru;
            },
            locationId: {
                get: function () {
                    return this.object.location_id || '';
                },
                set: function (value) {
                    this.object.location_id = value
                        ? value
                        : null;
                }
            }
        },
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// resources/js/components/schedule/Event.vue